import React, { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../RootReducer";
import { useLocation } from "react-router";
import { getContainer } from "../../ioc/IOCSetup";
import DesktopTopMenu, { includeMenuItemForCountry } from "./DesktopTopMenu";
import Scrollbars from "react-custom-scrollbars-2";
import { BrandA } from "../buttons/buttons";
import { NavLink } from "react-router-dom";
import Submenu from "./Submenu";
import { MenuItemData, isCasinoMenuItemActive, mapMenuItem } from "./MenuUtils";
import { openFreshChat } from "../FreshChatWidget";
import AppInstallComponent from "../AppInstallComponent";
import { ReactNode } from "react-markdown";
import { AppMode, MenuPosition } from "../../http/protocol";
import NavMenu from "./NavMenu";
import MobileBottomMenu from "./MobileBottomMenu";
import { showSideMenu } from "../../navigation/NavigationActions";
import { useClickOutside } from "../../onboardingpage/modalview/utils";
import { InfoPagePayload, StyledText } from "../../contenful/types";
import { MenuCloseButton } from "./Menu";
import LanguageMenu from "../language/LanguageMenu";
import { t } from "../../i18n";
import { StyledTextComponent } from "../../landingpage/pagesection/HeroBannerTwoColumnsComponent";
import { getIsGlifeContext } from "../../selectors/settings-selectors";
import { getAppMode } from "../../selectors/user-selectors";
import SideMenuComponents from "./menucomponents/SideMenuComponents";
import { contentfulImageUrl } from "./menucomponents/SideMenuContent";

interface AbsoluteLayoutProps {
  position?: MenuPosition;
  isExpanded?: boolean;
  children: ReactNode[] | ReactNode;
}
export default function AbsoluteLayout(props: AbsoluteLayoutProps) {
  const isMobile = useSelector((app: AppState) => app.settings.mobile);

  const sidebarRef = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(showSideMenu(false));
  };

  useClickOutside(sidebarRef, handleClick);

  return (
    <>
      <aside ref={sidebarRef} className={`show-side-menu absolute ${props.isExpanded ? "show" : "hide"}`}>
        <div className={"desktop-side-menu absolute"}>{<AbsoluteSideMenu />}</div>
      </aside>
      {isMobile ? <NavMenu /> : <DesktopTopMenu />}
      {isMobile && <MobileBottomMenu />}
      {props.children}
    </>
  );
}

export const AbsoluteSideMenu = () => {
  const freshChatEnabled = useSelector((app: AppState) => app.settings.settings?.freshChatEnabled);
  const isLoggedIn = useSelector((app: AppState) => app.user.user?.loggedIn);
  const isExpanded = useSelector((app: AppState) => app.navigation.isSideMenuExpanded);
  const content = useSelector((app: AppState) => app.contentful.sideMenuContent);
  const country = useSelector((app: AppState) => app.user.user?.country);
  const ipCountry = useSelector((app: AppState) => app.settings.country);
  const footer = useSelector((app: AppState) => app.contentful.footer);
  const menuSettings = useSelector((app: AppState) => app.settings.settings?.menu?.settings);
  const location = useLocation();
  const dispatch = useDispatch();
  const isGlifeContext = useSelector(getIsGlifeContext);
  const isEmbeddedAppMode = useSelector(getAppMode) === AppMode.EMBEDDED;

  const closeSidebar = (menuItem: MenuItemData) => {
    dispatch(showSideMenu(!isExpanded));
  };
  const onClose = () => {
    dispatch(showSideMenu(!isExpanded));
  };
  let footerPages: Array<InfoPagePayload> = [];
  if (footer && footer.infoPagesHighlighted) {
    footerPages = footerPages.concat(footer.infoPagesHighlighted);
  }

  let locale = getContainer().getSettingsService().getActiveLocale().code;
  let items = getContainer().getSettingsService().getMenu().items;

  items = items?.filter((m) => includeMenuItemForCountry(m, country, ipCountry));
  let footerTextId: any = [];
  let appModeLogo = getContainer().getSettingsService().getAppModeLogo();
  return (
    <Scrollbars>
      <div className="original-sidemenu">
        <div className={"close-button"} onClick={() => dispatch(showSideMenu(false))}>
          <MenuCloseButton />
        </div>
        <div>
          <LanguageMenu inNavMenu={true} />
        </div>
        {!isLoggedIn && (
          <>
            <div className={"side-menu-content"}>
              {content && content.html && content.html.length > 0 && <div className={`side-menu-custom logged-out`} dangerouslySetInnerHTML={{ __html: content.html }}></div>}
              {isGlifeContext && isEmbeddedAppMode && appModeLogo ? (
                <div className={"image"} style={{ backgroundImage: `url('${appModeLogo}')` }}></div>
              ) : (
                content && content.image && <div className={"image"} style={{ backgroundImage: `url('${contentfulImageUrl(content?.image)}')` }}></div>
              )}
              <div className={"text"}>
                {content && content?.title && <div className={"title"}>{content.title}</div>}
                {content && content?.tagline && <div className={"tagline"}>{content.tagline}</div>}
              </div>
            </div>
            <SideMenuComponents position={menuSettings?.position} onClose={() => console.log("fris")} component={menuSettings?.menuComponents} />
          </>
        )}
        {isLoggedIn && <SideMenuComponents position={menuSettings?.position} onClose={() => console.log("fris")} component={menuSettings?.menuComponents} />}
        {isLoggedIn && content && content.html && content.html.length > 0 && <div className={`side-menu-custom logged-in`} dangerouslySetInnerHTML={{ __html: content.html }}></div>}
        <div className="menu-items">
          {items &&
            items
              .map((rawMenuItem) => mapMenuItem(rawMenuItem, locale, location.pathname))
              .map((processedMenuItem) => {
                if (processedMenuItem) {
                  return (
                    <>
                      {processedMenuItem.external && !processedMenuItem.subMenu && (
                        <BrandA className={"nav-link submenu-link"} href={processedMenuItem.url} key={processedMenuItem.name} target={processedMenuItem.target} onClick={() => closeSidebar(processedMenuItem)}>
                          {processedMenuItem.icon?.className && <i className={"" + processedMenuItem?.icon?.className}></i>}
                          {processedMenuItem.text}
                        </BrandA>
                      )}
                      {!processedMenuItem.external && !processedMenuItem.subMenu && (
                        <NavLink
                          className={"nav-link submenu-link expandable" + processedMenuItem.className}
                          to={processedMenuItem.url}
                          key={processedMenuItem.name}
                          isActive={(match, location) => isCasinoMenuItemActive(match, location, processedMenuItem)}
                          activeClassName={"active"}
                          onClick={() => closeSidebar(processedMenuItem)}
                        >
                          {processedMenuItem.icon?.className && <i className={"" + processedMenuItem.icon.className}></i>}
                          {processedMenuItem.text}
                        </NavLink>
                      )}
                      {processedMenuItem.subMenu && <Submenu key={processedMenuItem.url} menuItem={processedMenuItem} close={onClose} />}
                    </>
                  );
                }
              })}
        </div>
        <div className={"footer-items"}>
          {footerPages &&
            footerPages
              .filter((i) => !!i)
              .map((i) => {
                return (
                  <NavLink key={i?.id ?? i?.nameId} className={"nav-link"} to={"/info/" + (i?.id ?? i?.nameId)} onClick={() => onClose()}>
                    {i?.id ?? i?.nameId}
                  </NavLink>
                );
              })}
          {footer?.dynamicContent?.map((d: any) => {
            return d.styledTextList?.map((s: any) => {
              return s.styledTexts?.map((t: StyledText) => {
                if (t.showSideMenu && footerTextId.indexOf(t._id) < 0) {
                  footerTextId.push(t._id);
                  return (
                    <NavLink key={t._id} className={`nav-link ${t.cssClassName ? t.cssClassName : ""}`} to={`${t.textLink ? t.textLink : "/"}`} onClick={() => onClose()}>
                      <StyledTextComponent st={t} key={t._id} loggedIn={isLoggedIn} isSideMenu={true} />
                    </NavLink>
                  );
                }
              });
            });
          })}
          {freshChatEnabled && (
            <a
              href="#"
              className={"nav-link"}
              onClick={() => {
                openFreshChat();
                dispatch(showSideMenu(false));
              }}
            >
              {t("navmenu.support")}
            </a>
          )}
          <div className={"app-install-container"}>
            <div className={"app-install-container"}>
              <AppInstallComponent />
            </div>
          </div>
        </div>
      </div>
    </Scrollbars>
  );
};
